// Develoment
// export const BASE_URL                 =  'https://fup.famrut.com/web_services/';
// export const FARMER_LOGIN_URL         =  'https://fup.famrut.com/fup-farmer/';
// export const ADMIN_LOGIN_URL          =  'https://fup.famrut.com/fup-admin/';
// export let DEFAULT_LANG               =  'en';

// QA
// export const BASE_URL              = 'https://qa.famrut.com/web_services/';
// export const FARMER_LOGIN_URL      =  'https://qa.famrut.com/fup-farmer/'
// export const ADMIN_LOGIN_URL         =  'https://qa.famrut.com/fup-admin/';
// export const DEFAULT_LANG          =  'ori';

// UAT
// export const BASE_URL              = 'https://uat.famrut.com/web_services/';
// export const FARMER_LOGIN_URL      =  'https://uat.famrut.com/fup-farmer/';
// export const ADMIN_LOGIN_URL         =  'https://uat.famrut.com/fup-admin/';
// export const DEFAULT_LANG          =  'ori';


//DEV UAT QA matomo urls
// export const MATOMO_BASE_URL          = 'https://analytics.famrut.com/index.php';
// export const MATOMO_TRACKER_URL       =  '//analytics.famrut.com/'
// export const MATOMO_SITE_ID           =  5;

// Live
export const BASE_URL              = 'https://fup.odisha.gov.in/web_services/';
export const FARMER_LOGIN_URL      =  'https://fup.odisha.gov.in/fup-farmer/';
export const ADMIN_LOGIN_URL       =  'https://fup.odisha.gov.in/fup-admin/';
export const DEFAULT_LANG          =  'ori';
export const MATOMO_BASE_URL       = 'https://analytics-fup.odisha.gov.in/index.php';
export const MATOMO_TRACKER_URL    =  '//analytics-fup.odisha.gov.in/'
export const MATOMO_SITE_ID        =  1;